import { useState } from 'react';

export default function WorksheetSwishHero() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <section className="relative bg-gradient-to-br from-purple-50 via-pink-50 to-rose-50 py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full mb-6 shadow-sm">
              <i className="ri-brain-line text-2xl text-purple-600"></i>
              <span className="text-sm font-medium text-gray-700">Técnica Swish — PNL</span>
            </div>
            
            <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Worksheet de Prática da<br />
              <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                Técnica Swish
              </span>
            </h1>
            
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Reprograme suas respostas automáticas e substitua padrões mentais indesejados por comportamentos fortalecedores em minutos.
            </p>

            <div className="flex flex-wrap items-center justify-center gap-4 mb-8">
              <button
                onClick={() => document.getElementById('pratica-swish')?.scrollIntoView({ behavior: 'smooth' })}
                className="px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full font-semibold hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap"
              >
                Começar Agora
              </button>
              
              <button
                onClick={() => setShowModal(true)}
                className="px-8 py-4 bg-white text-purple-600 rounded-full font-semibold hover:shadow-lg transition-all duration-300 border-2 border-purple-200 whitespace-nowrap"
              >
                <i className="ri-information-line mr-2"></i>
                Como Funciona
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
              <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Rápido</h3>
                <p className="text-sm text-gray-600">Resultados em 5-10 minutos de prática</p>
              </div>

              <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-gradient-to-br from-pink-500 to-rose-500 rounded-xl flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-refresh-line text-2xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Automático</h3>
                <p className="text-sm text-gray-600">Instala novos padrões no subconsciente</p>
              </div>

              <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-gradient-to-br from-rose-500 to-orange-500 rounded-xl flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-checkbox-circle-line text-2xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Eficaz</h3>
                <p className="text-sm text-gray-600">Validado por milhares de praticantes</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-6" onClick={() => setShowModal(false)}>
          <div className="bg-white rounded-3xl max-w-2xl w-full p-8 shadow-2xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-3xl font-bold text-gray-900">Princípio da Técnica</h2>
              <button
                onClick={() => setShowModal(false)}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="space-y-6">
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6">
                <h3 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                  <i className="ri-lightbulb-line text-xl text-purple-600"></i>
                  O Cérebro Responde a Imagens Internas
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Muitas reações emocionais não são escolhas conscientes — são respostas automáticas aprendidas ao longo do tempo. O Swish permite substituir rapidamente imagens internas que geram ansiedade ou bloqueio por representações mentais que evocam segurança, clareza e controle.
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="font-semibold text-gray-900 flex items-center gap-2">
                  <i className="ri-arrow-right-line text-xl text-purple-600"></i>
                  O Swish Altera:
                </h3>
                
                <div className="grid gap-4">
                  <div className="flex items-start gap-3 bg-gray-50 rounded-xl p-4">
                    <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-image-line text-purple-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">A Imagem que Dispara o Padrão</h4>
                      <p className="text-sm text-gray-600">Identificamos a imagem mental indesejada que ativa o comportamento ou emoção negativa</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3 bg-gray-50 rounded-xl p-4">
                    <div className="w-8 h-8 bg-pink-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-restart-line text-pink-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">A Resposta Automática Associada</h4>
                      <p className="text-sm text-gray-600">Substituímos por uma nova imagem fortalecedora que gera a resposta desejada</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-6 border-2 border-amber-200">
                <h3 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                  <i className="ri-star-line text-xl text-amber-600"></i>
                  Por Que Funciona
                </h3>
                <p className="text-gray-700 leading-relaxed mb-3">
                  O cérebro aprende associações rápidas. Com o Swish, você está:
                </p>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2 text-gray-700">
                    <i className="ri-check-line text-amber-600 mt-1"></i>
                    <span>Substituindo o "atalho mental" antigo</span>
                  </li>
                  <li className="flex items-start gap-2 text-gray-700">
                    <i className="ri-check-line text-amber-600 mt-1"></i>
                    <span>Criando um novo padrão automático</span>
                  </li>
                  <li className="flex items-start gap-2 text-gray-700">
                    <i className="ri-check-line text-amber-600 mt-1"></i>
                    <span>Redirecionando atenção e emoção</span>
                  </li>
                </ul>
              </div>
            </div>

            <button
              onClick={() => setShowModal(false)}
              className="w-full mt-6 px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300 whitespace-nowrap"
            >
              Entendi, Vamos Começar!
            </button>
          </div>
        </div>
      )}
    </>
  );
}